// 国内版本默认配置

/**
 * BASE_API 接口域名
 * BASE_MICRO_APPS 微前端子应用域名
 */
const config = {
  local: {
    APP_ID: 101797,
    // BASE_API: 'http://10.37.210.44:8080',
    BASE_API: 'gatekeeper-test.nioint.com',
    POWERPRO_API: 'gatekeeper-test.nioint.com',
    BASE_MICRO_APPS: 'power-micro-apps-test.nio.com'
  },
  dev: {
    APP_ID: 101797,
    BASE_API: 'gatekeeper-dev.nioint.com',
    POWERPRO_API: 'gatekeeper-dev.nioint.com',
    BASE_MICRO_APPS: 'power-micro-apps-dev.nio.com'
  },
  test: {
    APP_ID: 101797,
    BASE_API: 'gatekeeper-test.nioint.com',
    POWERPRO_API: 'gatekeeper-test.nioint.com',
    BASE_MICRO_APPS: 'power-micro-apps-test.nio.com'
  },
  stg: {
    APP_ID: 101797,
    BASE_API: 'gatekeeper-stg.nio.com',
    POWERPRO_API: 'gatekeeper-stg.nio.com',
    BASE_MICRO_APPS: 'power-micro-apps-stg.nio.com'
  },
  prod: {
    APP_ID: 101797,
    BASE_API: 'gatekeeper.nio.com',
    POWERPRO_API: 'gatekeeper.nio.com',
    BASE_MICRO_APPS: 'power-micro-apps.nio.com'
  }
}

module.exports = config
